import { Button, FormControl, InputLabel, MenuItem, Select, TextField, DialogContent, DialogTitle, IconButton } from "@mui/material";
import styles from "./Popup.module.css";
import axios from "axios";
import { forwardRef, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { authData } from "../../components/GetAuth";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Amount(&pound;)*" variant="outlined" fullWidth />));

const AddProductForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [parentList, setParentList] = useState([]);
  const { handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      parent_id: "",
      amount: "",
    },
  });

  useEffect(() => {
    const fetchCategory = () => {
      axios.get(process.env.REACT_APP_API_URL + "v1/category-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        let itemData = response.data.data;
        setParentList(itemData);
      }).catch((error) => { });
    };

    fetchCategory();
  }, [API_TOKEN]);

  useEffect(() => {
    if (editData) {
      setValue("title", editData?.title);
      setValue("amount", editData?.amount);
      setValue("parent_id", editData?.parent_id);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);
    data.is_fragile = 0;
    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/products/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/products", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      {editData ? "Update Product" : "Add Product"}
      <IconButton onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="category-label">Category*</InputLabel>
              <Controller
                name="parent_id"
                control={control}
                rules={{ required: "This field is Required" }}
                render={({ field }) => (
                  <Select {...field} labelId="category-label" label="Category*">
                    {parentList?.map((val) => {
                      return (<MenuItem key={val?.value} value={val?.value}>
                        {val?.label}
                      </MenuItem>);
                    })}
                  </Select>
                )}
              />
            </FormControl>
            {errors.parent_id && (<span className={`${styles.ErrorM}`}>{errors?.parent_id?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="title"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Title*" variant="outlined" fullWidth />)}
            />
            {errors.title && (<span className={`${styles.ErrorM}`}>{errors?.title?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="amount"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<NumericFormat {...field} customInput={CustomInput} decimalScale={2} />)}
            />
            {errors.amount && (<span className={`${styles.ErrorM}`}>{errors?.amount?.message}</span>)}
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpen(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">{editData ? "Update" : "Add"}</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default AddProductForm;